import React from 'react';

interface IProps {
  size?: string;
  color?: string;
}

const CloseXIcon: React.FC<IProps> = ({ size = '18' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    className={`h-[${size}px] w-[${size}px]`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15 5L5 15" stroke='currentColor' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 5L15 15" stroke='currentColor' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default CloseXIcon;
